import { GridCellProps } from '@progress/kendo-react-grid';
import * as fabric from 'office-ui-fabric-react';
import { useState, VFC } from 'react';
import { KendoLoading } from '../../../../components';
import { deleteButtonStyles, editButtonStyles } from '../../../../components/custom/ListItemActionButtons';
import { useConfirmation } from '../../../../components/dialogs';

interface IProps {
    fetchData: () => Promise<void>;
    deleteItem: (infoScreenId: number) => Promise<void>;
    editItem: (infoScreenId: number) => void;
    locked?: boolean;
}

const AdministrationActionCell: VFC<GridCellProps & IProps> = ({ dataItem, fetchData, deleteItem, editItem, locked }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { confirmAsync } = useConfirmation();

    const handleDelete = async (id: number) => {
        try {
            const { success } = await confirmAsync(
                'Įrašo ištrynimas',
                'Ar tikrai norite ištrinti pasirinktą įrašą? Ištrynę įrašą, jo atkurti nebegalėsite.'
            );

            if (!success) {
                return;
            }
            setIsLoading(true);
            await deleteItem(id);
            fetchData();
        } catch (ex) {
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return <KendoLoading />;
    }

    return (
        <td>
            <div>
                {editItem && (
                    <fabric.IconButton
                        onClick={() => editItem(dataItem.id)}
                        disabled={locked}
                        iconProps={{
                            iconName: 'PageEdit'
                        }}
                        styles={editButtonStyles}
                    />
                )}
                <fabric.IconButton
                    onClick={async () => await handleDelete(dataItem.id)}
                    iconProps={{
                        iconName: 'Trash'
                    }}
                    styles={deleteButtonStyles}
                />
            </div>
        </td>
    );
};

export default AdministrationActionCell;
